import {Component, effect, inject} from '@angular/core';
import {TableVerticalControlComponent} from 'frontier/browserkit';
import {INITIAL_STATE_TOKEN} from 'frontier/nucleus';
import {ProcessOverviewStore} from '../../../service/process-overview.store';
import {MatProgressBar} from '@angular/material/progress-bar';
import AppControlGuids from '../../../../../../api/ControlGuids';
import {
  TableVerticalControlCoreComponent
} from "frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control-core/table-vertical-control-core.component";

@Component({
  selector: 'app-ordinance-detail',
  templateUrl: '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control.component.html',
  styleUrl: '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control.component.scss',
  standalone: true,
  imports: [MatProgressBar, TableVerticalControlCoreComponent],
  providers: [
    {provide: INITIAL_STATE_TOKEN, useValue: {filter: null}}
  ]
})
export class OrdinanceDetailComponent extends TableVerticalControlComponent {
  private _processOverviewService = inject(ProcessOverviewStore);
  selectedCart = this._processOverviewService.selectedCart;
  override GUID = AppControlGuids.TOrdinanceList;

  constructor() {
    super();
    effect(() => {
      const selectedCart = this.selectedCart();
      if (selectedCart) {
        this.patchFilter({
          parent: selectedCart.obj,
          typename: 'cart',
        });
      }
    }, {allowSignalWrites: true});
  }
}
